import { Info } from '@nike/nike-design-system-icons';
import PropTypes from 'prop-types';
import React from 'react';

import './ToolTip.css';

const ToolTip = ({
 children, inline, left, top
}) => (
  <section
    className={inline ? 'tool-tip tool-tip--inline' : 'tool-tip'}
    style={inline
      ? {
 display: 'inline-block', marginLeft: '6px', position: 'relative', verticalAlign: 'middle', zIndex: 200
}
      : { left, position: 'absolute', top }}
  >
    <Info />
    <article className="ncss-col-sm-8 ta-sm-l tool-tip-content" style={{ zIndex: 2 }}>
      <span>{children}</span>
    </article>
  </section>
);

ToolTip.defaultProps = {
  inline: false,
  left: '',
  top: undefined,
};

ToolTip.propTypes = {
  children: PropTypes.node.isRequired,
  inline: PropTypes.bool,
  left: PropTypes.string,
  top: PropTypes.string,
};

export default ToolTip;
